import React from 'react';
import PageLayout from '../../layouts/pagelayout';
import VedantAtGlance from '../../layouts/overview/vedanta-at-glance';
import WhatDoWeDo from '../../layouts/overview/what-do-we-do';
import WellResourcedLongTermValue from '../../layouts/overview/well-resourced-long-term-value';
import WhatDrivesUs from '../../layouts/overview/what-drives-us';
import WhatUnderpinsUs from '../../layouts/overview/what-underpins-us';
import Asignificant from '../../layouts/overview/asignificant';
import HighlightsOfTheYear from '../../layouts/overview/highlight-of-the-year';
import WellStructuredDeliver from '../../layouts/overview/well-structured-deliver';
import OurBusinessScale from '../../layouts/overview/our-business-scale';
import BreadCrumb from '../../components/breadcrumb';

class Overview extends React.Component {
  render() {
    return (
      <PageLayout pageTitle="Vedanta - Overview" pageLink="/overview/vedanta-at-a-glance">
        <div className="overview-page">
          <BreadCrumb />
          <VedantAtGlance />
          <WhatDoWeDo />
          <WellResourcedLongTermValue />
          <WhatDrivesUs />
          <WhatUnderpinsUs />
          <Asignificant />
          <HighlightsOfTheYear />
          <WellStructuredDeliver />
          <OurBusinessScale />
        </div>
      </PageLayout>
    );
  }
}

export default Overview;
